import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=050e9816&scoped=true&"
import script from "./Codes.vue?vue&type=script&lang=js&"
export * from "./Codes.vue?vue&type=script&lang=js&"
import style0 from "./Codes.vue?vue&type=style&index=0&id=050e9816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e9816",
  null
  
)

export default component.exports